// Views
import Login from '../views/Auth/Login';
import Logout from '../views/Auth/Logout';
import ForgotPassword from '../views/Auth/ForgotPassword';
import ResetPassword from '../views/Auth/ResetPassword';
import Establishment from '../views/Establishment';
import Administration from '../views/Administration';

export default [
  // AUTH
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/logout',
    element: <Logout />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },

  // PAGES
  {
    path: '/',
    element: <Administration />,
  },
  {
    path: '/establishment',
    element: <Establishment />,
  },
];
